/* Isolated outfit cart interaction. No tracking configuration or global cart code. */
if (!customElements.get('ek-look-bundle')) {
  customElements.define('ek-look-bundle', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.querySelector('form');
      this.button = this.querySelector('[data-add-look]');
      this.status = this.querySelector('[data-look-status]');
      this.total = this.querySelector('[data-look-total]');
      this.cards = [...this.querySelectorAll('[data-look-item]')];
      this.money = value => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency', currency: this.dataset.currency
      }).format(value / 100);
      this.cards.forEach(card => {
        card.variants = JSON.parse(card.querySelector('[data-variants]').textContent);
        const control = card.querySelector('[data-look-variant]');
        control?.addEventListener('change', () => {
          const variant = card.variants.find(v => String(v.id) === control.value);
          if (variant) {
            card.querySelector('.look-price').textContent = this.money(variant.price);
            const img = card.querySelector('.look-product-image img');
            if (variant.image) { img.removeAttribute('srcset'); img.src = variant.image; }
            card.querySelectorAll('.look-shop,.look-product-image').forEach(a => a.href = variant.url);
          }
          this.update();
        });
      });
      this.classList.add('bundle-ready');
      this.update();
      this.form.addEventListener('submit', event => this.add(event));
    }
    update() {
      let subtotal = 0;
      let blocked = this.cards.length === 0;
      this.cards.forEach(card => {
        const control = card.querySelector('[data-look-variant]');
        const chosen = card.variants.find(v => String(v.id) === control?.value);
        const available = card.variants.find(v => v.available);
        subtotal += (chosen || available || card.variants[0])?.price || 0;
        if (!available || card.dataset.invalidVariant === 'true' || (chosen && !chosen.available)) blocked = true;
      });
      this.total.textContent = this.money(subtotal);
      this.button.disabled = blocked;
      this.button.textContent = this.dataset.addLabel.replace('[count]', this.cards.length);
      this.status.textContent = blocked ? this.dataset.unavailable : this.dataset.choose;
    }
    async add(event) {
      event.preventDefault();
      if (this.busy || !this.form.reportValidity()) return;
      const items = this.cards.map(card => ({
        id: Number(card.querySelector('[data-look-variant]')?.value), quantity: 1
      }));
      if (items.some(item => !Number.isSafeInteger(item.id) || item.id <= 0)) return;
      this.busy = true;
      this.button.disabled = true;
      this.form.setAttribute('aria-busy', 'true');
      this.button.textContent = this.dataset.loading;
      this.status.textContent = '';
      try {
        const response = await fetch(this.dataset.addUrl, {
          method: 'POST', credentials: 'same-origin',
          headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          body: JSON.stringify({items})
        });
        const result = await response.json();
        if (!response.ok || result.status >= 400) {
          this.status.textContent = result.description || result.message || this.dataset.error;
          this.status.setAttribute('role', 'alert');
          this.button.textContent = this.dataset.addLabel.replace('[count]', this.cards.length);
          this.button.disabled = false;
          this.busy = false;
          this.form.removeAttribute('aria-busy');
          return;
        }
        // The real cart page refreshes all native counts and exposes checkout in one click.
        window.location.assign(this.dataset.cartUrl);
      } catch (_) {
        // An uncertain network response must not silently add the outfit again.
        this.status.textContent = this.dataset.error;
        this.status.setAttribute('role', 'alert');
        this.button.textContent = this.dataset.checkBag;
        this.button.disabled = true;
        this.form.removeAttribute('aria-busy');
      }
    }
  });
}
